













































































































import {Component, Vue} from 'vue-property-decorator';
import IconButton from '@c/controls/IconButton.vue';
import CancelChangesDialog from '@c/CancelChangesDialog.vue';
import router from '@/router';
import bearingsStoreModule from '@/store/modules/bearingsModule';

@Component({
  components: {
    IconButton,
    CancelChangesDialog,
  },
})
export default class Bearings extends Vue {
  loading = false;
  saving = false;

  valid = true;

  bearing: any = [];

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';
  RegExPattern = /^([0-9A-Fa-f]{12})$/;
  nonEmptyNumberRule = (v: any) => v != null || 'Поле обязательно для заполнения';
  nonNegativeNumberRule = (v: any) => v >= -1 || 'Поле должно быть неотрицательным числом';
  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';

  async onSave() {
    const err_container = this.$refs.err_text as any;
    this.valid = await (this.$refs.form as any).validate();
    if (!this.valid) {
      const error = document.querySelector('div.error--text');
      error && this.$vuetify.goTo(error as HTMLElement);
      return;
    }
    if (err_container) err_container.innerText = 'Обрабатываю...';
    try {
      await bearingsStoreModule.save(this.bearing);
    } catch (err) {
      console.log(err);
      if (err_container) err_container.innerText = 'Ошибка обновления: ' + err;
      return;
    }
    if (err_container) err_container.innerText = '';
    router.push('/bearings');
  }

  //переменная, сигнализирующая о внесенных и несохраненных изменениях на форме
  changed = false;

  // Действия при изменении поля
  async onChange() {
    this.changed = true;
  }

  async created() {
    const bearingId = this.$router.currentRoute.params.id;
    if (bearingId) {
      await bearingsStoreModule.fetchAll();
      const all = bearingsStoreModule.all;
      this.bearing = all.find(x => `${x.id}` == bearingId);
    } else {
      this.bearing = {
        name: '',
        description: '',
        inner_ring: 0,
        outer_ring: 0,
        roller: 0,
        roller_count: 0,
        roller_angle: 0,
        cage_frequency: 0,
        roller_frequency: 0,
        outer_frequency: 0,
        inner_frequency: 0,
      };
    }
  }

  get cancelChangesDialog() {
    return this.$refs.cancelChangesDialog as any;
  }

  recalc_freq() {
    const b = {...this.bearing};
    const a = Math.cos((parseFloat(b.roller_angle) / 180.0) * Math.PI);
    const s = parseFloat(b.inner_ring) + parseFloat(b.outer_ring);
    b.cage_frequency = 0.5 - (parseFloat(b.roller) * a) / s;
    b.outer_frequency = b.cage_frequency * parseInt(b.roller_count);
    b.inner_frequency = parseInt(b.roller_count) * (0.5 + (parseFloat(b.roller) * a) / s);
    b.roller_frequency =
      (b.cage_frequency * b.inner_frequency * s) / parseInt(b.roller_count) / parseFloat(b.roller);
    this.bearing = b;
    this.changed = true;
  }

  back() {
    // если были внесены изменения на форме
    if (this.changed) {
      this.cancelChangesDialog.open('/bearings');
    } else router.push('/bearings');
  }
}
